<style>
.input-readonly > div > .vs-inputx {
  background-color: #e6e6e6;
}
</style> 
<template>
  <div class="vx-col w-5/6 ml-auto mr-auto">
    <span>
      <h4 class="mb-5">Supplier Credit Note</h4>
    </span>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="DN Number"
          name="DN Number"
          v-model="dn_number"
          placeholder="DN Number"
          readonly
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full"
          label="Notes"
          name="Notes"
          v-model="notes"
          placeholder="Notes"
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full"
          label="Supplier Credit Note Number"
          name="Supplier Credit Note Number"
          v-model="cn_number"
          placeholder="Supplier Credit Note Number"
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <label class="vs-input--label">Supplier Credit Note Date</label>
        <datepicker
          class="w-full"
          :inline="false"
          name="Invoice Date"
          v-model="cn_date"
          placeholder="Select Supplier Credit Note Date"
        ></datepicker>
      </div>
    </div>

    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full"
          label="Tax Return Number"
          name="Tax Return Number"
          v-model="tr_number"
          @keypress="isNumberAndFormat($event)"
          placeholder="Tax Return Number"
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <label class="vs-input--label">Tax Return Date</label>
        <datepicker
          class="w-full"
          :inline="false"
          name="Invoice Date"
          v-model="tr_date"
          placeholder="Select Tax Return Date"
        ></datepicker>
      </div>
    </div>
    <div class="vx-row mb-2 ml-1">
      <h5>Line Item</h5>
    </div>
    <vs-table stripe border description :sst="true" :data="table.data">
      <template slot="thead">
        <vs-th>Item</vs-th>
        <vs-th>Price</vs-th>
        <vs-th>Damaged Quantity</vs-th>
        <vs-th>Tax Rate</vs-th>
        <vs-th>Quantity</vs-th>
        <vs-th>Value</vs-th>
        <vs-th>Tax</vs-th>
        <vs-th>Total</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :data="tr"
          :key="indextr"
          v-for="(tr, indextr) in data"
          :class="data[indextr].class"
        >
          <vs-td :data="data[indextr].code">
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ data[indextr].item_name }}</span><br>
              <span class="w-5/5">{{ data[indextr].batch }}</span>
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              {{ parseFloat(table.purchase_order.lines.filter(i => {
                return i.item_unit_id = data[indextr].item_unit_id_return
              })[0].price_pcs).toFixed(2).toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              {{ data[indextr].damage_quantity }} {{ data[indextr].unit_name }}
            </div>
          </vs-td>
          <vs-td>
            <vs-input
                class="w-full mb-2 input-readonly"
                name="Tax Rate"
                label="Tax Rate"
                :value="
                  parseFloat(data[indextr].tax_rate)
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                readonly
              />
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <vs-input
                class="w-full mb-2 input-readonly"
                name="Quantity Return"
                label="Quantity Return"
                :value="
                  data[indextr].return_quantity
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                readonly
              />
              <vs-input
                v-validate="'required'"
                class="w-full"
                name="Quantity Debit Note"
                label="Quantity Debit Note"
                v-model="data[indextr].dn_quantity"
                @input="formatNumber(indextr, 'dn_quantity')"
                placeholder="Quantity DN"
                @keypress="isNumber($event)"
              />
              <span
                class="text-danger text-sm"
                v-if="data[indextr].dn_quantity == null && status_submit"
                >This field is required</span
              >
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <vs-input
                class="w-full mb-2 input-readonly"
                name="Return Value"
                label="Return Value"
                :value="
                  parseFloat(data[indextr].return_value)
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                readonly
              />
              <vs-input
                v-validate="'required'"
                class="w-full"
                name="Debit Note Value"
                label="Debit Note Value"
                v-model="data[indextr].dn_value"
                @input="formatNumber(indextr, 'dn_value')"
                placeholder="DN Value"
                @keypress="isNumber($event)"
              />
              <span
                class="text-danger text-sm"
                v-if="data[indextr].dn_value == null && status_submit"
                >This field is required</span
              >
            </div>
          </vs-td>
          
          <vs-td>
            <div class="vx-row ml-0">
              <vs-input
                class="w-full mb-2 input-readonly"
                name="Return Tax"
                label="Return Tax"
                :value="
                  parseFloat(data[indextr].return_tax)
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                readonly
              />
              <vs-input
                v-validate="'required'"
                class="w-full"
                name="Debit Note Tax"
                label="Debit Note Tax"
                v-model="data[indextr].dn_tax"
                @input="formatNumber(indextr, 'dn_tax')"
                placeholder="DN Tax"
                @keypress="isNumber($event)"
              />
              <span
                class="text-danger text-sm"
                v-if="data[indextr].dn_tax == null && status_submit"
                >This field is required</span
              >
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <vs-input
                class="w-full mb-2 input-readonly"
                name="Return Total"
                label="Return Total"
                :value="
                  parseFloat(data[indextr].return_total)
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                readonly
              />
              <vs-input
                class="w-full input-readonly"
                name="Debit Note Total"
                label="Debit Note Total"
                v-model="data[indextr].dn_total"
                placeholder="DN Total"
                readonly
              />
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="DPP"
          name="DPP"
          v-model="dpp"
          readonly
        />
      </div>
    </div>  
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Tax"
          name="Tax"
          v-model="total_ppn"
          readonly
        />
      </div>
    </div>  
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Total"
          name="Total"
          v-model="total_dn"
          readonly
        />
      </div>
    </div> 
    <div class="vx-row mb-6 mt-6">
      <div class="vx-col w-full" style="margin-bottom: 150px">
        <vs-button class="mb-2" @click="handleSubmit"
          >Save & Approval</vs-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    Datepicker,
  },
  props: {
    po_code: {
      type: String,
    },
    po_date: {
      type: String,
    },
    po_id: {
      type: Number,
    },
    po_virtual_code: {
      type: String,
    },
    purchase_receive_code: {
      type: String,
    },
    purchase_receive_id: {
      type: Number,
    },
    purchase_return_code: {
      type: String,
    },
    purchase_return_id: {
      type: Number,
    },
    received_date: {
      type: String,
    },
    supplier_address: {
      type: String,
    },
    supplier_city: {
      type: String,
    },
    supplier_code: {
      type: String,
    },
    supplier_contact_name: {
      type: String,
    },
    supplier_name: {
      type: String,
    },
    supplier_phone: {
      type: String,
    },
    warehouse_code: {
      type: String,
    },
    warehouse_id: {
      type: Number,
    },
    warehouse_name: {
      type: String,
    },
    dn_number: {
      type: String,
    },
    notes: {
      type: String,
    },
    source: {
      type: String,
    },
  },
  created() {},
  data() {
    return this.initialState();
  },
  methods: {
    initialState() {
      return {
        search: "",
        offset: 0,
        limit: 10,
        status_submit: false,
        table: {
          data: [],
          purchase_order: {}
        },
        // dn_number: null,
        cn_number: null,
        cn_date: null,
        tr_number: null,
        tr_date: null,
      };
    },
    handleClose() {
      window.scrollTo(0, 0);
      this.$emit("close");
    },
    paramData() {
      return {
        dn_number: this.dn_number,
        territory_id: this.$userLogin.territory_id,
        territory_area_id: this.$userLogin.territory_area_id,
        po_code: this.po_code,
        po_date: this.po_date,
        po_id: this.po_id,
        po_virtual_code: this.po_virtual_code,
        purchase_receive_code: this.purchase_receive_code,
        purchase_receive_id: this.purchase_receive_id,
        purchase_return_code: this.purchase_return_code,
        purchase_return_id: this.purchase_return_id,
        received_date: this.received_date,
        supplier_address: this.supplier_address,
        supplier_city: this.supplier_city,
        supplier_code: this.supplier_code,
        supplier_contact_name: this.supplier_contact_name,
        supplier_name: this.supplier_name,
        supplier_phone: this.supplier_phone,
        warehouse_code: this.warehouse_code,
        warehouse_id: this.warehouse_id,
        warehouse_name: this.warehouse_name,
        supplier_cn_number: this.cn_number,
        supplier_cn_date: this.cn_date,
        tax_return_number: this.tr_number,
        tax_return_date: this.tr_date,
        data: this.table.data,
        status: "0",
        type: "Return",
        notes: this.notes,
      };
    },
    handleSubmit() {
      this.status_submit = true;
      this.$validator.validateAll().then((result) => {
        if (result) {
          console.log(this.paramData());
          this.$vs.loading();
          this.postData();
        }
      });
    },
    postData() {
      this.$http
        .post("/api/v1/debit-note/", this.paramData())
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.handleClose();
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    formatNumber(index, type) {
      if (this.table.data[index][type].replace(/,/g, "").length < 16) {
        var str = this.table.data[index][type].toString().split(".");
        if (str.length > 2) {
          this.table.data[index][type] = this.table.data[index][type]
            .toString()
            .replace(/\.+$/, "");
        }

        if (str.length == 2) {
          if (str[1].length > 3) {
            this.table.data[index][type] = this.table.data[index][type]
              .toString()
              .slice(0, -1);
          }
        }

        this.table.data[index][type] = this.table.data[index][type]
          .replace(/,/g, "")
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        if(type == "dn_value" || type == "dn_tax"){
          this.table.data[index]["dn_total"] = (parseFloat(this.table.data[index]["dn_value"].replace(/,/g, "")) + parseFloat(this.table.data[index]["dn_tax"].replace(/,/g, ""))).toFixed(2).toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
      } else {
        this.table.data[index][type] = this.table.data[index][type]
          .toString()
          .slice(0, -1);
      }
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumberAndFormat: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      if (charCode != 8 && this.tr_number != null) {
        if (this.tr_number.length == 3) {
          this.tr_number = this.tr_number + ".";
        } else if (this.tr_number.length == 7) {
          this.tr_number = this.tr_number + "-";
        } else if (this.tr_number.length == 10) {
          this.tr_number = this.tr_number + ".";
        } else if (this.tr_number.length > 18) {
          evt.preventDefault();
          // this.$nextTick(() => {
          //   let a = this.tr_number.toString().substr(0, 19)
          //   this.tr_number = a

          // })
        }
      }
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get("/api/v1/debit-note/line", {
          params: {
            purchase_return_id: this.purchase_return_id,
            po_id: this.po_id
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            // this.table.data = resp.data.records;
            // console.log(resp.data.records)
            this.table.purchase_order = resp.data.purchase_order;
            resp.data.purchase_return.records.map((row) => {
              if (this.source == "import") {
                this.table.data.push({
                  ...row,
                  ...{
                    amount_uom: row.amount_uom,
                    batch: row.batch,
                    damage_quantity: row.damage_quantity,
                    item_name: row.item_name,
                    item_unit_id_recieve: row.item_unit_id_recieve,
                    item_unit_id_return: row.item_unit_id_return,
                    price_pcs: row.price_pcs,
                    unit_name: row.unit_name,
                    return_quantity: row.return_quantity.toString(),
                    return_value: row.return_value.toString(),
                    dn_quantity: row.return_quantity.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                    dn_value: row.return_value.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                    
                    return_tax: (row.return_value * (10/100)).toString(),
                    return_total: ((row.return_value * (10/100)) + row.return_value).toString(),
                    dn_tax: (row.return_value * (10/100)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                    dn_total: ((row.return_value * (10/100)) + row.return_value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                  },
                });
              } else {
                this.table.data.push({
                  ...row,
                  ...{
                    amount_uom: row.amount_uom,
                    batch: row.batch,
                    damage_quantity: row.damage_quantity,
                    item_name: row.item_name,
                    item_unit_id_recieve: row.item_unit_id_recieve,
                    item_unit_id_return: row.item_unit_id_return,
                    price_pcs: row.price_pcs,
                    return_quantity: row.return_quantity.toString(),
                    return_value: row.return_value.toString(),
                    return_tax: (row.return_value * (row.tax_rate/100)).toString(),
                    return_total: ((row.return_value * (row.tax_rate/100)) + row.return_value).toString(),
                    unit_name: row.unit_name,
                  },
                });
              }
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
  },
  mounted() {
    if (this.purchase_return_id) {
      this.getData();
    }
  },
  computed: {
    dpp() {
      return this.table.data.map(item => {
          if (isNaN(item.dn_value)) {
            var str = item.dn_value.toString().replace(/,/g, "")
            return parseFloat(str)
          } else {
            return item.dn_value
          }
      }).reduce((prev, curr) => prev + curr, 0).toFixed(2).toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    total_ppn() {
      return this.table.data.map(item => {
        if (isNaN(item.dn_tax)) {
          console.log(item.dn_tax)
          var str = item.dn_tax.toString().replace(/,/g, "")
          return parseFloat(str)
        } else {
          return item.dn_tax
        }
      }).reduce((prev, curr) => prev + curr, 0).toFixed(2).toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    total_dn() {
      return this.table.data.map(item => {
        console.log(item)
        if (isNaN(item.dn_total)) {
          var str = item.dn_total.toString().replace(/,/g, "")
          return parseFloat(str)
        } else {
          return item.dn_total
        }
      }).reduce((prev, curr) => prev + curr, 0).toFixed(2).toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  watch: {
    purchase_return_id() {
      Object.assign(this.$data, this.initialState());
      this.getData();
    },
  },
};
</script>
<style scoped>
.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}

.pagination button {
  flex-grow: 1;
}

.pagination button:hover {
  cursor: pointer;
}

.horizontal-divider {
  border-top: 1px solid #c1bbff;
  padding: 5px;
  margin-top: 15px;
}
</style>